import React, { Suspense } from 'react';
import ErrorBoundary from '../../../Molecules/Common/error/ErrorBoundary';
import "bootstrap/js/dist/modal";
import "bootstrap/js/dist/dropdown";
import "bootstrap/js/dist/tooltip";
import "bootstrap/dist/css/bootstrap.css";
import PropTypes from "prop-types";
import { safeLazy } from '../../../../Utils/safeLazy';
import RemoteFallback from './RemoteFallback_MFE_Editor';

const RichTextEditorMFE = safeLazy(() => import('WYSIWYG_Editor/A_RichTextEditor'), RemoteFallback);

const A_RichTextEditor = ({
  label,
  defaultValue,
  disabled,
  onChange,
  inputMaxLength,
  id,
  required,
  removeStyle,
  height,
}) => {
  return (
    <Suspense fallback={"Loading..."}>
      <ErrorBoundary>
        <RichTextEditorMFE
          id={id}
          label={label}
          defaultValue={defaultValue}
          disabled={disabled}
          onChange={onChange}
          inputMaxLength={inputMaxLength}
          required={required}
          removeStyle={removeStyle}
          height={height}
        />
      </ErrorBoundary >
    </Suspense>
  );
};

A_RichTextEditor.propTypes = {
  label: PropTypes.string,
  defaultValue: PropTypes.string,
  disabled: PropTypes.bool,
  onChange: PropTypes.func,
  inputMaxLength: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  id: PropTypes.string,
  required: PropTypes.bool,
  fieldHelperText: PropTypes.string,
  removeStyle: PropTypes.bool,
  height: PropTypes.string
};

export default A_RichTextEditor;

// import React, { useRef } from 'react';
// import Editor from './Editor';
// import './A_RichTextEditor.css';
// import PropTypes from "prop-types";
// import "quill/dist/quill.snow.css";
// import { makeStyles } from "@material-ui/core/styles";
// import { cleanHtml, ligntCleanHtml } from './A_RichTextEditorHelper';
// import "bootstrap/js/dist/modal";
// import "bootstrap/js/dist/dropdown";
// import "bootstrap/js/dist/tooltip";
// import "bootstrap/dist/css/bootstrap.css";

// const useStyles = makeStyles(() => ({
//   label: {
//     padding: 0,
//     fontSize: "1rem",
//     fontFamily: "inherit",
//     fontWeight: 400,
//     marginTop: "16px",
//     marginBottom: "10px",
//   },
//   quillContainerWrapper: {
//     borderRadius: "4px",
//     display: "flex",
//     flexDirection: "column",
//     width: "100%",
//   },
//   quill: {
//     flexGrow: 1,
//     display: "flex",
//     flexDirection: "column",
//     "& .ql-toolbar": {
//       borderTopLeftRadius: "4px",
//       borderTopRightRadius: "4px",
//       borderBottom: "1px solid #ccc",
//     },
//     "& .ql-container": {
//       flexGrow: 1,
//       display: "flex",
//       flexDirection: "column",
//       padding: 0,
//       border: "none",
//     },
//     "& .ql-editor": {
//       minHeight: "100px",
//       height: "auto",
//       fontSize: "1rem",
//       fontFamily: "Arial, sans-serif",
//       color: "black",
//       padding: "4px 8px",
//       overflowY: "auto",
//       wordBreak: "break-word",
//     },
//   },
// }));

// const A_RichTextEditor = ({
//   label = "",
//   defaultValue = "",
//   disabled,
//   onChange,
//   inputMaxLength,
//   id,
//   required,
//   removeStyle = true,
//   height = "",
// }) => {
//   const quillRef = useRef(null);
//   const classes = useStyles();
//   let styledRemoved =
//       (removeStyle == false) ||
//         (removeStyle &&
//           typeof removeStyle == "string" &&
//           removeStyle.toLowerCase() == "false")
//         ? false
//         : true;

//   return (
//     <div style={{ display: "flex", flexDirection: "column", width: "99%", marginBottom: "10px" }}>
//       <label className={classes.label}>
//         {label} {required && "*"}
//       </label>
//       <div className={classes.quillContainerWrapper}>
//         <Editor
//           id={id}
//           ref={quillRef}
//           defaultValue={defaultValue}
//           disabled={disabled}
//           removeStyle={removeStyle}
//           inputMaxLength={inputMaxLength}
//           height={height ? height : ""}
//           onTextChange={(value) => {
//             if (onChange) {
//               // eslint-disable-next-line no-console
//               console.log(`onChange called for fieldId: ${id}: `, value);
//               if (value) {
//                 if (styledRemoved === false) {
//                   onChange(ligntCleanHtml(value), id)
//                 }
//                 else {
//                   onChange(cleanHtml(value), id)
//                 }
//               }
//               }
//             }
//           }
//         />
//       </div>
//     </div>
//   );
// };

// A_RichTextEditor.propTypes = {
//   label: PropTypes.string,
//   defaultValue: PropTypes.string,
//   disabled: PropTypes.bool,
//   onChange: PropTypes.func,
//   inputMaxLength: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
//   id: PropTypes.string,
//   required: PropTypes.bool,
//   fieldHelperText: PropTypes.string,
//   removeStyle: PropTypes.bool,
//   height: PropTypes.string
// };

// export default A_RichTextEditor;
